import Vue from "vue";
import Vuex from "vuex"
import Cookie from "js-cookie"
import {getManageConfigSetting} from "@/api/setting-api";
import {getFileUrl} from "@/utils/fileUploadUtils";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loginInfo: {},
        employeeLoginInfo: {},

        token: "",
        accountType: "",    // manage, employee
        roleType: "",        // ADMIN MANAGE VIEW GUARD STAFF COMMON
        roleData: null,        // ADMIN MANAGE VIEW GUARD STAFF COMMON
        myPermissions: [],

        pageInfo: {},
        myArriveDepartmentIds: [],
        myApplyDepartmentIds: [],
        myArriveAreaIds:[],
        myApplyAreaIds:[],

        passwd: "",

        fixButtonPassTime: 0,

        guardSignList: [],
        systemSetting: {
            systemName: "",
            companyLogo: "",
        }
    },

    actions: {
        initData({commit}) {

            let loginInfo = Cookie.get("loginInfo")
            console.log("*** loginInfo", loginInfo)
            if (loginInfo) {
                commit('setLoginData', JSON.parse(loginInfo))
            }
            let employeeLoginInfo = Cookie.get("employeeLoginInfo")
            console.log("*** employeeLoginInfo", employeeLoginInfo)
            if (employeeLoginInfo) {
                commit('setEmployeeLoginData', JSON.parse(employeeLoginInfo))
            }
            // let roleData = Cookie.get("roleData")
            let roleData = localStorage.getItem("roleData")
            console.log("*** roleData", roleData)
            if (roleData) {
                commit('setRoleData', JSON.parse(roleData))
            }

            let pageInfo = Cookie.get("pageInfo")
            console.log("*** pageInfo", pageInfo)
            if (pageInfo) {
                commit('setPageInfo', JSON.parse(pageInfo))
            }

            let passwd = Cookie.get("passwd")
            if (passwd) {
                commit('setPasswd', passwd)
            }

            if (!loginInfo && !employeeLoginInfo) {
                commit('setRoleData', {})
                commit('setPageInfo', {})
                commit('setPasswd', "")
            }
            let guardSignList = localStorage.getItem("guardSignList")
            if (guardSignList) {
                commit('setGuardSignList', JSON.parse(guardSignList))
            }
        },

        setupSystemSetting() {
            getManageConfigSetting().then(({data}) => {
                if (data.code === 200) {
                    let systemSetting = {systemName: "", companyLogo: ""}
                    data.data.forEach(item => {
                        if (item.type === "SYSTEM_NAME") {
                            let content = item.content
                            if (content) {
                                systemSetting.systemName = content
                            }
                        } else if (item.type === "COMPANY_LOGO") {
                            let content = item.content
                            if (content) {
                                systemSetting.companyLogo = getFileUrl(content)
                            }
                        }
                    })
                    this.commit("setSystemSetting", systemSetting)
                }
            })
        },
    },

    mutations: {
        doOnLogout(state) {
            state.loginInfo = {}
            state.employeeLoginInfo = {}
            state.token = ""
            state.accountType = ""
            state.roleType = ""
            state.roleData = null
            state.myPermissions = []
            state.pageInfo = {}
            state.myArriveDepartmentIds = []
            state.myApplyDepartmentIds = []
            state.myArriveAreaIds = []
            state.myApplyAreaIds = []
            state.passwd = ""
            state.fixButtonPassTime = 0
            // localStorage.clear()
            localStorage.removeItem("roleData")
            localStorage.removeItem("myData")

            const cookies = Cookie.get();
            for (let cookie in cookies) {
                Cookie.remove(cookie);
            }
        },
        setLoginData(state, data) {
            state.loginInfo = data

            if (data && data.token && data.roleType) {
                state.token = data.token
                state.accountType = "manage"
                state.roleType = data.roleType

                Cookie.set("loginInfo", JSON.stringify(data))
            } else {
                state.accountType = ""
                Cookie.remove("loginInfo")
            }
        },

        setEmployeeLoginData(state, data) {
            state.employeeLoginInfo = data

            if (data && data.token && data.roleType) {
                state.token = data.token
                state.accountType = "employee"
                state.roleType = data.roleType

                Cookie.set("employeeLoginInfo", JSON.stringify(data))
            } else {
                state.accountType = ""
                Cookie.remove("employeeLoginInfo")
            }
        },

        setRoleData(state, data) {
            console.log("store setRoleData", data)
            state.roleData = data
            if (data) {
                localStorage.setItem("roleData", JSON.stringify(data))
                // Cookie.set("roleData", JSON.stringify(data))
            } else {
                localStorage.removeItem("roleData")
                // Cookie.remove("roleData")
            }
        },

        setPageInfo(state, data) {
            state.pageInfo = data
            if (data) {
                Cookie.set("pageInfo", JSON.stringify(data))
            } else {
                Cookie.remove("pageInfo")
            }
        },

        setMyPermission(state, data) {
            state.myPermissions = data
        },

        setMyArriveDepartmentIds(state, data) {
            state.myArriveDepartmentIds = data
        },
        setMyApplyDepartmentIds(state, data) {
            state.myApplyDepartmentIds = data
        },

        setMyArriveAreaIds(state, data) {
            state.myArriveAreaIds = data
        },

        setMyApplyAreaIds(state, data) {
            state.myApplyAreaIds = data
        },

        setToken(state, data) {
            state.token = data
        },

        setPasswd(state, data) {
            state.passwd = data
            if (data) {
                Cookie.set("passwd", data)
            } else {
                Cookie.remove("passwd")
            }
        },

        setFixButtonCheckPassTime(state, data) {
            state.fixButtonPassTime = data
        },

        setGuardSignList(state, data) {
            state.guardSignList = data
            if (data) {
                // localStorage.setItem
                localStorage.setItem("guardSignList", JSON.stringify(data))
            }
        },
        setSystemSetting(state, data) {
            state.systemSetting = data
        },
    },

    getters: {}
})
